<template>
  <div class="index">
    <header class="hd">
      <span class="logo">
        <img src="../assets/image/index/logo.png" alt="logo" class="logo-icon">| 增值服务商
      </span>
      <a href="tel:4006350088" class="tel">400-635-0088</a>
    </header>
    <img class="banner" src="../assets/image/index/banner.png" />
    <main class="container">
      <div class="pro-info m-b-30">
        <h2 class="info-title">400电话办理优势</h2>
        <img class="advantage-img" src="../assets/image/index/400.png" />
      </div>
      <div class="pro-info m-b-30">
        <h2 class="info-title">400特色功能</h2>
        <ul class="ability-list">
          <li class="ability-item">
            <img src="../assets/image/index/abi-1.png" class="m-b-10" />
            <div class="ability-text">彩铃功能</div>
          </li>
          <li class="ability-item">
            <img src="../assets/image/index/abi-2.png" class="m-b-10" />
            <div class="ability-text">来电弹屏</div>
          </li>
          <li class="ability-item">
            <img src="../assets/image/index/abi-3.png" class="m-b-10" />
            <div class="ability-text">转接分机</div>
          </li>
          <li class="ability-item">
            <img src="../assets/image/index/abi-4.png" class="m-b-10" />
            <div class="ability-text">IVR语音导航功能</div>
          </li>
          <li class="ability-item">
            <img src="../assets/image/index/abi-5.png" class="m-b-10" />
            <div class="ability-text">通话录音</div>
          </li>
          <li class="ability-item">
            <img src="../assets/image/index/abi-6.png" class="m-b-10" />
            <div class="ability-text">满意度调查</div>
          </li>
          <li class="ability-item">
            <img src="../assets/image/index/abi-7.png" class="m-b-10" />
            <div class="ability-text">报工号</div>
          </li>
          <li class="ability-item">
            <img src="../assets/image/index/abi-8.png" class="m-b-10" />
            <div class="ability-text">挂机短信</div>
          </li>
          <li class="ability-item">
            <img src="../assets/image/index/abi-9.png" class="m-b-10" />
            <div class="ability-text">来电记忆</div>
          </li>
          <li class="ability-item">
            <img src="../assets/image/index/abi-10.png" class="m-b-10" />
            <div class="ability-text">语音留言</div>
          </li>
        </ul>
      </div>
      <div class="pro-info m-b-30">
        <h2 class="info-title">办理流程</h2>
        <ul class="process-list">
          <li class="process-item process-1">
            <div class="process-name">第一步: 选择号码套餐</div>
            <div>在线咨询、挑选心仪的企业400电话</div>
          </li>
          <li class="process-item process-2">
            <div class="process-name">第二步: 提交企业资料</div>
            <div>签订合同、提交公司相关资料审核</div>
          </li>
          <li class="process-item process-3">
            <div class="process-name">第三步: 号码开通使用</div>
            <div>预存话费、号码开通独立后台管理</div>
          </li>
        </ul>
      </div>
      <div class="pro-info m-b-30">
        <h2 class="info-title">安全与支持</h2>
        <ul class="support-list">
          <li class="support-item support-1">
            <div class="support-name">独立售前、售后团队</div>
            <div>确保长期售后无忧</div>
          </li>
          <li class="support-item support-2">
            <div class="support-name">7*24小时全年服务</div>
            <div>专业客服一对一</div>
          </li>
          <li class="support-item support-3">
            <div class="support-name">工信部全国资政认证</div>
            <div>增值电信业务运营商（全国）</div>
          </li>
          <li class="support-item support-4">
            <div class="support-name">专业技术团队支持</div>
            <div>全面满足您的技术需要</div>
          </li>
        </ul>
      </div>
      <div class="pro-info">
        <h2 class="info-title">他们也在使用</h2>
        <ul class="user-list">
          <li class="user-item">
            <img src="../assets/image/index/user-1.png" />
          </li>
          <li class="user-item">
            <img src="../assets/image/index/user-2.png" />
          </li>
          <li class="user-item">
            <img src="../assets/image/index/user-3.png" />
          </li>
          <li class="user-item">
            <img src="../assets/image/index/user-4.png" />
          </li>
          <li class="user-item">
            <img src="../assets/image/index/user-5.png" />
          </li>
          <li class="user-item">
            <img src="../assets/image/index/user-6.png" />
          </li>
          <li class="user-item">
            <img src="../assets/image/index/user-7.png" />
          </li>
          <li class="user-item">
            <img src="../assets/image/index/user-8.png" />
          </li>
        </ul>
      </div>
    </main>
    <footer>
      <div class="ft-cont">
        <div class="service-center">
          <h2 class="ft-title">客服中心</h2>
          <div class="service-item">
            <div>7*24小时售前咨询热线</div>
            <a class="service-tel" href="tel:4000211188">400-635-0088</a>
          </div>
        </div>
        <div class="wx-area">
          <h2 class="ft-title">关注微信</h2>
          <img src="../assets/image/index/wx.png" class="wx-icon" alt="wx">
        </div>
      </div>
      <div class="copyright-text">
        <p>上海金润信息技术有限公司 沪ICP备11009254号 </p>
        <p>Copyright © 2015-2024版权所有</p>
        <p class="m-b-20">工信部跨地区增值电信业务许可证（全国）B2-20110056</p>
        <p>沪公网安备 31011002002847号</p>
      </div>
    </footer>
  </div>
</template>

<script>

export default {
  name: 'index'
}
</script>

<style lang="scss" scoped>
.hd {
  padding: 0 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  font-size: 12px;
  color: $flush-orange;
  .logo {
    display: flex;
    align-items: center;
    font-size: 9px;
    .logo-icon {
      width: 71px;
      margin-right: 5px;
    }
  }
  .tel {
    padding-left: 20px;
    background: url(../assets/image/index/tel.png) no-repeat 0 center;
    background-size: 13px;
    text-decoration: none;
    color: inherit;
  }
}
.container {
  padding: 10px 20px 25px;
  border-bottom: 1px solid $mercury;
  .info-title {
    position: relative;
    color: $curious-blue;
    font-size: 16px;
    margin-bottom: 30px;
    text-align: center;
    font-weight: bold;
    padding-bottom: 4px;
    &:after {
      content: "";
      position: absolute;
      left: 50%;
      bottom: 0;
      background: $denim;
      height: 2px;
      width: 28px;
      transform: translateX(-50%);
    }
  }
  .ability-list {
    padding: 0 10px;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-gap: 24px 24px;
    font-size: 8px;
  }
  .process-list {
    margin: 0 30px;
    background: url(../assets/image/index/line.png) no-repeat right 0;
    background-size: 6px;
    font-size: 10px;
    color: $dove-gray;
    .process-name {
      font-size: 14px;
      color: #333;
      font-weight: bold;
      margin-bottom: 6px;
    }
    .process-item {
      margin-bottom: 30px;
    }
    .process-1 {
      background: url(../assets/image/index/process-1.png) no-repeat 0 0;
      background-size: 30px;
    }
    .process-2 {
      background: url(../assets/image/index/process-2.png) no-repeat 0 0;
      background-size: 30px;
    }
    .process-3 {
      background: url(../assets/image/index/process-3.png) no-repeat 0 0;
      background-size: 30px;
    }
  }
  .support-list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 25px 50px;
    font-size: 8px;
    color: $dove-gray;
    .support-name {
      font-size: 12px;
      color: #333;
      font-weight: bold;
      margin-bottom: 5px;
    }
    .support-item {
      padding-left: 40px;
    }
    .support-1 {
      background: url(../assets/image/index/support-1.png) no-repeat 0 0;
      background-size: 25px;
    }
    .support-2 {
      background: url(../assets/image/index/support-2.png) no-repeat 0 0;
      background-size: 25px;
    }
    .support-3 {
      background: url(../assets/image/index/support-3.png) no-repeat 0 0;
      background-size: 25px;
    }
    .support-4 {
      background: url(../assets/image/index/support-4.png) no-repeat 0 0;
      background-size: 25px;
    }
  }
  .user-list {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 28px 32px;
  }
}
img {
  width: 100%;
}
footer {
  padding: 18px 25px 32px;
  .ft-cont {
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;
  }
  .ft-title {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 12px;
  }
  .service-center {
    text-align: left;
    .ft-title {
      margin-bottom: 30px;
    }
  }
  .service-item {
    font-size: 12px;
    margin-bottom: 16px;
  }
  .service-tel {
    display: block;
    text-decoration: none;
    color: $flush-orange;
    font-size: 16px;
    margin-top: 10px;
  }
  .copyright-text {
    color: $dusty-gray;
    font-size: 10px;
    line-height: 16px;
  }
  .wx-icon {
    width: 119px;
  }
}
</style>
